// import {combineReducers} from 'redux';
import {
  CAR_COLOR_OPTIONS, CAR_TYPE_OPTIONS, MODEL_YEAR_OPTIONS,
  PROVINCE_OPTIONS,VEHICLE_TYPE_OPTIONS,POLICY_TYPE_OPTIONS
} from './FormUtils';

const api = require('api');
// const reducers = combineReducers({
//   message:api.getMessage()
// });

let counter = 0;
const initialState = {
  counter,
  formData: {},
  data: {},
  message: api.getMessage(),
  modalState: {
    carBrand: false,
    carSeries: false,
    color: false,
    customer: false,
  },
  options: {
    model_year_options: MODEL_YEAR_OPTIONS,
    province_options: PROVINCE_OPTIONS,
    car_type_options: CAR_TYPE_OPTIONS,
    vehicle_type_options: VEHICLE_TYPE_OPTIONS,
    color_options: CAR_COLOR_OPTIONS,
    policy_type_options : POLICY_TYPE_OPTIONS,
    brand_options: [
      {
        label: '...',
        value: 0,
      }],
    model_options: [
      {
        label: '...',
        value: 0,
      }],
    series_options: [
      {
        label: '...',
        value: 0,
      }],
  },
};

export function FormReducer(state = initialState, action) {
  // console.log('reducer', action);
  switch (action.type) {
    case 'ADD_COUNTER':
      return {
        ...state,
        counter: ++counter,
      };
    case 'SET_OPTION':
      return {
        ...state,
        options: {
          ...state.options,
          ...action.options,
        },
      };
    case 'ADD_OPTION':
      return {
        ...state,
        options: {
          ...state.options,
          [action.field]: [
            ...state.options[action.field],
            action.values,
          ],
        },
      };

    case 'SET_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
      };

    default:
      // console.log('default state', state);
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/component/element/workdoc/FormReducer.js